import { CustomField } from '../../../../types/camposPersonalizados';

interface FieldValue {
    id_campo_personalizado: number;
    valor: string;
}

interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

const handleStageFieldsUpdate = async (
    opportunityId: number,
    newStageId: number,
    apiService: any
): Promise<void> => {
    try {
        // 1. Buscar os campos personalizados da nova etapa
        const customFieldsResponse = await apiService.getCustomFields(undefined, newStageId);
        const customFields = customFieldsResponse.data as CustomField[];
        
        console.log('Campos obrigatórios:', customFields.filter(f => f.obrigatorio));

        if (!customFields || customFields.length === 0) {
            console.log('Nenhum campo personalizado encontrado para esta etapa');
            return;
        }

        // 2. Buscar os valores existentes dos campos para esta oportunidade
        const existingValuesResponse = await apiService.getFieldValues(opportunityId);
        const existingValues = (existingValuesResponse.data || []) as FieldValue[];

        // 3. Mapear todos os valores existentes para fácil acesso
        const existingValueMap: Record<number, any> = {};
        existingValues.forEach(value => {
            existingValueMap[value.id_campo_personalizado] = value.valor;
        });

        // 4. Preparar valores para todos os campos obrigatórios
        const requiredFields = customFields.filter(campo => campo.obrigatorio);
        const valuesToSave: FieldValue[] = [];

        for (const campo of requiredFields) {
            // Verificar se já existe um valor
            const valorExistente = existingValueMap[campo.id];
            let valorFinal;

            if (valorExistente !== undefined && valorExistente !== null && valorExistente !== '') {
                // Manter o valor existente (formatando conforme necessário)
                if (campo.tipo_campo === 'checkbox') {
                    valorFinal = valorExistente === true || valorExistente === "1" ? "1" : "0";
                } else if (campo.tipo_campo === 'multiselect' && valorExistente === '') {
                    // Corrigir multiselect com valor vazio
                    valorFinal = '[]';
                } else {
                    valorFinal = valorExistente;
                }
            } else {
                // Definir valor padrão conforme o tipo
                switch (campo.tipo_campo) {
                    case 'checkbox':
                        valorFinal = campo.valor_padrao === "1" ? "1" : "0";
                        break;
                    case 'numero':
                    case 'monetario':
                    case 'porcentagem':
                        valorFinal = campo.valor_padrao || "0";
                        break;
                    case 'multiselect':
                        // Sempre usar array JSON para multiselect
                        if (campo.opcoes) {
                            try {
                                const opcoes = typeof campo.opcoes === 'string' 
                                    ? JSON.parse(campo.opcoes) 
                                    : campo.opcoes;
                                    
                                if (Array.isArray(opcoes) && opcoes.length > 0) {
                                    valorFinal = JSON.stringify([opcoes[0].id]);
                                } else {
                                    valorFinal = '[]';
                                }
                            } catch (e) {
                                valorFinal = '[]';
                            }
                        } else {
                            valorFinal = '[]';
                        }
                        break;
                    case 'select':
                    case 'radio':
                        // Se tiver valor padrão definido, usar
                        if (campo.valor_padrao) {
                            valorFinal = campo.valor_padrao;
                        }
                        // Senão, tentar pegar a primeira opção, se existir
                        else if (campo.opcoes) {
                            try {
                                const opcoes = typeof campo.opcoes === 'string' 
                                    ? JSON.parse(campo.opcoes) 
                                    : campo.opcoes;
                                    
                                if (Array.isArray(opcoes) && opcoes.length > 0) {
                                    valorFinal = opcoes[0].id.toString();
                                } else {
                                    valorFinal = "";
                                }
                            } catch (e) {
                                valorFinal = "";
                            }
                        } else {
                            valorFinal = "";
                        }
                        break;
                    case 'data':
                        valorFinal = campo.valor_padrao || new Date().toISOString().split('T')[0];
                        break;
                    case 'hora':
                        valorFinal = campo.valor_padrao || "";
                        break;
                    default:
                        valorFinal = campo.valor_padrao || "";
                }
            }

            console.log(`Campo ${campo.id} (${campo.titulo} - ${campo.tipo_campo}): ${valorFinal}`);

            valuesToSave.push({
                id_campo_personalizado: campo.id,
                valor: valorFinal
            });
        }

        // 5. Salvar apenas se houver valores para salvar
        if (valuesToSave.length > 0) {
            console.log('Valores a serem salvos:', valuesToSave);
            await apiService.saveFieldValues(opportunityId, valuesToSave);
            console.log('Valores dos campos atualizados com sucesso');
        } else {
            console.log('Nenhum valor novo para salvar');
        }

    } catch (error: unknown) {
        console.error('Erro ao atualizar campos da etapa:', error);
        console.error('Detalhes do erro:', error);
        
        // Capturar resposta da API se disponível
        if (error && typeof error === 'object' && 'response' in error) {
            console.error('Resposta da API:', (error as any).response?.data);
        }
        
        throw error;
    }
};

export default handleStageFieldsUpdate;